/**
 * @desc ToB客户审批信息-分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.BusinessCustomerApprovalPageListResponseDto>
>;
export function request(
  params: API.basics.businessCustomer.approvalPageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/businessCustomer/approvalPageList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
